export default __webpack_public_path__ + "static/media/Dashboard-documentation.4c19dfe1.md";